export const getViewsByParent = <T>(views, parentName: T) =>
  views.filter((view) => view.parent === parentName);
